import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=ab4b6848&scoped=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=ab4b6848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4b6848",
  null
  
)

export default component.exports